import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const BitbucketShadedWhite = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();
  return (
    <Icon ref={ref} viewBox="0 0 16 16" {...props}>
      <path
        d="M14.3873 5.91932H10.1912L9.49189 10.0455H6.57796L3.15119 14.125C3.15119 14.125 3.31436 14.2649 3.54747 14.2649H12.6856C12.8954 14.2649 13.0819 14.1017 13.1285 13.8919L14.3873 5.91932Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <path
        d="M1.44941 1.69995C1.16966 1.69995 0.959885 1.95638 1.00651 2.21281L2.89475 13.7754C2.91806 13.9153 2.988 14.0551 3.10456 14.1484C3.10456 14.1484 3.26773 14.2882 3.50085 14.2882L7.04422 10.0455H6.55468L5.78538 5.91938L10.1912 5.91932H14.3873L14.9935 2.21281C15.0402 1.93307 14.8303 1.69995 14.5506 1.69995H1.44941Z"
        fill="white"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${iconPrefix}__a`}
          x1={15.6896}
          x2={6.58189}
          y1={4.47522}
          y2={9.56762}
        >
          <stop offset={0.0718327} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default BitbucketShadedWhite;
